export class OptionChainEnvironment {
  public static getName = () => 'benzinga-option-chain';
  public static getEnvironment = (env: Record<string, string>) => ({
    apiKey: env.apiKey ?? '',
    url: new URL(env.url ?? 'https://data-api.benzinga.com/'),
  });
}
